import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { HiOutlineDevicePhoneMobile, HiOutlineSparkles } from "react-icons/hi2";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import "./AppComingSoonSection.css";
export default function AppComingSoonSection() {
  useLanguage();
  return <section className="bb-app-coming-soon">
      <Container>
        <div className="bb-app-coming-soon__shell">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="bb-app-coming-soon__content">
                <span className="bb-app-coming-soon__badge">
                  <HiOutlineSparkles />{t("Mobile Experience Coming Soon")}

                </span>

                <h2 className="bb-app-coming-soon__title">{t("BaytBuddy is coming soon to iOS and Android")}

                </h2>

                <p className="bb-app-coming-soon__text">{t("We are building a smoother mobile experience so users can browse room listings, manage their profile, and stay connected on the go with even more convenience.")}



                </p>

                <p className="bb-app-coming-soon__subtext">{t("The BaytBuddy mobile app is being prepared to make shared living discovery in Saudi Arabia more accessible, faster, and more user-friendly from anywhere.")}



                </p>

                <div className="bb-app-coming-soon__highlights">
                  <div className="bb-app-coming-soon__highlight">
                    <span className="bb-app-coming-soon__highlight-dot" />{t("Easier room discovery on mobile")}

                  </div>

                  <div className="bb-app-coming-soon__highlight">
                    <span className="bb-app-coming-soon__highlight-dot" />{t("Profile and listing access anytime")}

                  </div>

                  <div className="bb-app-coming-soon__highlight">
                    <span className="bb-app-coming-soon__highlight-dot" />{t("Built for a better on-the-go experience")}

                  </div>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="bb-app-coming-soon__visual">
                <div className="bb-app-coming-soon__device-card">
                  <div className="bb-app-coming-soon__platforms">
                    <div className="bb-app-coming-soon__platform-card">
                      <div className="bb-app-coming-soon__platform-icon bb-app-coming-soon__platform-icon--ios">
                        <FaApple />
                      </div>
                      <div className="bb-app-coming-soon__platform-copy">
                        <div className="bb-app-coming-soon__platform-title">{t("iOS App")}</div>
                        <span>{t("Coming Soon")}</span>
                      </div>
                    </div>

                    <div className="bb-app-coming-soon__platform-card">
                      <div className="bb-app-coming-soon__platform-icon bb-app-coming-soon__platform-icon--android">
                        <FaGooglePlay />
                      </div>
                      <div className="bb-app-coming-soon__platform-copy">
                        <div className="bb-app-coming-soon__platform-title">{t("Android App")}</div>
                        <span>{t("Coming Soon")}</span>
                      </div>
                    </div>
                  </div>

                  <div className="bb-app-coming-soon__note">{t("Mobile access is on the roadmap to make BaytBuddy even more practical for everyday use.")}


                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>;
}
